class SubNavMenu {
    constructor(show) {
        const subnav = document.querySelector('#subnav');
        if (show) subnav.classList.add('show');

        this.subnavcontrol = document.createElement('div');
        subnav.parentElement.appendChild(this.subnavcontrol);
        this.subnavcontrol.classList.add('subnav-control');
        if (show) this.subnavcontrol.classList.add('show');

        this.subnavcontrol.appendChild(document.createElement('i'));

        this.button = this.subnavcontrol.appendChild(document.createElement('div'));
        const buttonText = document.createTextNode(show ? SubNavMenu.hideText() : SubNavMenu.showText());
        this.button.appendChild(buttonText);
    }

    static showText() {
        return 'Click to show menu';
    }

    static hideText() {
        return 'Click to hide menu';
    }

    toggle() {
        const { subnavcontrol } = this;
        const subnav = document.querySelector('#subnav');

        subnavcontrol.classList.toggle('show');
        subnav.classList.toggle('show');

        const show = subnavcontrol.classList.contains('show');
        this.button.innerText = show ? SubNavMenu.hideText() : SubNavMenu.showText();
    }
}

function toggleShowAll(...showAllButtons) {
    showAllButtons.forEach(showAllButton => {
        if (showAllButton.classList.contains('down')) {
            showAllButton.classList.remove('down');
            showAllButton.classList.add('up');
            showAllButton.innerText = 'Hide all';

            Array.from(document.querySelectorAll('dl.expand dt')).forEach(title => {
                const definition = title.nextElementSibling;

                if (title && definition) {
                    title.classList.add('open');
                    definition.classList.add('open');
                }
            });
        } else {
            showAllButton.classList.remove('up');
            showAllButton.classList.add('down');
            showAllButton.innerText = 'Show all';

            Array.from(document.querySelectorAll('dl.expand dt')).forEach(title => {
                const definition = title.nextElementSibling;

                if (title && definition) {
                    title.classList.remove('open');
                    definition.classList.remove('open');
                }
            });
        }
    });
}

function toggleListTitle(title) {
    const definition = title.nextElementSibling;

    if (title && definition) {
        if (title.classList.contains('open')) {
            title.classList.remove('open');
            definition.classList.remove('open');
        } else {
            title.classList.add('open');
            definition.classList.add('open');
        }
    }
}

function generateListIndex(list) {
    Array.from(list.querySelectorAll('dt')).forEach((title, i) => {
        if (title.id === '') {
            title.id = `list${i}`;
        }
    });

    const titles = Array.from(list.querySelectorAll('dt'));
    const index = {};

    const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    [...alpha].forEach(char => {
        const matchedTitle = [...titles].find(
            el =>
                el.textContent
                    .replace("'", '')
                    .substring(0, 1)
                    .toUpperCase() === char
        );

        if (matchedTitle) {
            index[char] = matchedTitle.id;
        } else {
            index[char] = null;
        }
    });

    return index;
}

function setFeedbackLink(link, feedbackId) {
    if (link) {
        const data = {};
        data.URL = window.location.pathname;
        const result = encodeURIComponent(data.URL);
        link.href = `/dynamic/${feedbackId}?url=${result}`;
    }
}

// eslint-disable-next-line no-undef
if (typeof Sentry !== 'undefined') Sentry.init({ dsn: 'https://11aae9b0f3054a9dbd63ef2b0a2d6632@sentry.io/1437310' });

// eslint-disable-next-line no-undef
const message = new Messages();
const survey = new Survey();

function getStorage(key) {
    const value = null;

    try {
        if (window.localStorage) {
            return window.localStorage.getItem(key);
        }
        // eslint-disable-next-line no-empty
    } catch {}

    return null;
}

function setStorage(key, value) {
    try {
        if (window.localStorage) {
            window.localStorage.setItem(key, value);
        }
        // eslint-disable-next-line no-empty
    } catch {}
}

// eslint-disable-next-line class-methods-use-this
function getSession(key) {
    try {
        if (window.sessionStorage) {
            const t = window.sessionStorage.getItem(key);
            if (parseInt(t) > Date.now()) return window.sessionStorage.getItem(key);
        }
        // eslint-disable-next-line no-empty
    } catch {}

    return null;
}

// eslint-disable-next-line class-methods-use-this
function setSession(key, timeout) {
    try {
        let d = new Date();
        d.setMinutes(d.getMinutes() + timeout);

        if (window.sessionStorage) window.sessionStorage.setItem(key, d.getTime());
        // eslint-disable-next-line no-empty
    } catch {}
}

document.addEventListener('DOMContentLoaded', () => {
    message.abbrInit();

    if (!getSession('survey-asked') && !getSession('survey-closed')) {
        if (typeof surveyType !== 'undefined') {
            survey.configureImmediate(surveyType);
        } else {
            const tag = document.querySelector("meta[name='page-type']");

            if (tag && tag.content.length > 0) {
                console.info(`Survey was initialised with page type ${tag.content}`);
                survey.configure(tag.content);
            } else {
                console.info(`No survey for this page`);
            }
        }
    }

    if (document.getElementById('site-message')) {
        const messageDatestamp = getStorage('message');

        if (!Number.isNaN(parseInt(messageDatestamp))) {
            const messageDate = new Date(parseInt(messageDatestamp));
            const today = new Date();
            const diff = Math.round((today - messageDate) / (1000 * 60 * 60));
            if (diff < 2) return;
        }

        $('#site-message').modal('show');
        setStorage('message', new Date().getTime());
    }

    const menu = document.querySelector('#menu');
    const menuButton = document.querySelector('#menu-button');
    const menuCloseButton = document.querySelector('#menu-close-button');

    if (menu && menuButton && menuCloseButton) {
        menu.addEventListener('transitionend', () => {
            if (menu.classList.contains('open')) {
                menu.style.cssText = 'position: absolute';
            } else {
                menu.style.cssText = 'position: fixed';
            }
        });

        menuButton.addEventListener('click', () => {
            menu.classList.add('open');
        });

        menuButton.addEventListener('keydown', e => {
            if (e.key !== 'Tab' && e.key !== 'Shift') {
                e.preventDefault();
                menu.classList.add('open');
                menuCloseButton.focus();
            }
        });

        menuCloseButton.addEventListener('click', () => {
            menu.classList.remove('open');
        });

        menuCloseButton.addEventListener('keydown', e => {
            if (e.key !== 'Tab' && e.key !== 'Shift') {
                e.preventDefault();
                menu.classList.remove('open');
                menuButton.focus();
            }
        });

        menuButton.setAttribute('tabindex', '0');
        menuCloseButton.setAttribute('tabindex', '0');
    }

    const search = document.querySelector('ul.navigation li.search');

    if (search) {
        const searchButton = search.querySelector('#search-icon');
        const searchBox = search.querySelector('input.inline-search-box');
        const line = document.querySelector('#line');

        searchButton.addEventListener('click', () => {
            search.classList.toggle('open');
            if (line && line.classList) line.classList.toggle('open');
            if (search.classList.contains('open')) {
                searchBox.value = '';
                searchBox.focus();
            }
        });
    }

    const pagecontent = document.querySelector('#pagecontent');
    const moreLink = document.querySelector('a.more-link');
    const lessLink = document.querySelector('a.less-link');

    if (moreLink && lessLink) {
        const moreid = `more_${moreLink.getAttribute('data-page')}`;

        if (sessionStorage.getItem(moreid) === 'true') {
            pagecontent.classList.add('detail_visible');
        }

        if (moreLink) {
            moreLink.addEventListener('click', e => {
                pagecontent.classList.add('detail_visible');
                sessionStorage.setItem(moreid, true);
                e.stopPropagation();
            });

            moreLink.addEventListener('keydown', e => {
                e.preventDefault();
                pagecontent.classList.add('detail_visible');
                sessionStorage.setItem(moreid, true);
                e.stopPropagation();
            });
        }

        if (lessLink) {
            lessLink.addEventListener('click', e => {
                pagecontent.classList.remove('detail_visible');
                sessionStorage.setItem(moreid, false);
                e.stopPropagation();
            });
            lessLink.addEventListener('keydown', e => {
                e.preventDefault();
                pagecontent.classList.remove('detail_visible');
                sessionStorage.setItem(moreid, false);
                e.stopPropagation();
            });
        }
    }

    const subnav = document.querySelector('#subnav');

    if (subnav && !document.querySelector('div.subnav-control')) {
        const subnavmenu = new SubNavMenu(false);

        subnavmenu.button.addEventListener('click', e => {
            subnavmenu.toggle();
            e.stopPropagation();
        });
    }

    const expandableLists = document.querySelectorAll('dl.expand');
    const expandableListTitles = document.querySelectorAll('dl.expand dt');

    const showAllButton = document.createElement('a');
    showAllButton.classList.add('button', 'action', 'down');
    showAllButton.href = '#';
    showAllButton.innerText = 'Show all';
    showAllButton.setAttribute('tabindex', '0');

    const showAllTopButton = showAllButton.cloneNode(true);

    showAllButton.addEventListener('click', () => {
        toggleShowAll(showAllButton, showAllTopButton);
    });
    showAllTopButton.addEventListener('click', () => {
        toggleShowAll(showAllButton, showAllTopButton);
    });
    showAllButton.addEventListener('keydown', e => {
        if (e.key !== 'Tab' && e.key !== 'Shift') {
            e.preventDefault();
            toggleShowAll(showAllButton, showAllTopButton);
        }
    });
    showAllTopButton.addEventListener('keydown', e => {
        if (e.key !== 'Tab' && e.key !== 'Shift') {
            e.preventDefault();
            toggleShowAll(showAllButton, showAllTopButton);
        }
    });

    Array.from(expandableLists).forEach(list => {
        const showAllDiv = document.createElement('div');
        showAllDiv.appendChild(showAllButton);
        const showAllTopDiv = document.createElement('div');
        showAllTopDiv.appendChild(showAllTopButton);

        list.insertAdjacentElement('afterend', showAllDiv);
        list.insertAdjacentElement('beforebegin', showAllTopDiv);

        if (list.classList.contains('index')) {
            const index = generateListIndex(list);
            const indexSection = document.createElement('div');
            indexSection.classList.add('list_index');

            Object.keys(index).forEach(i => {
                if (index[i]) {
                    const indexElement = document.createElement('a');
                    indexElement.innerText = i;
                    indexElement.href = `#${index[i]}`;
                    indexSection.appendChild(indexElement);
                }
            });

            list.insertAdjacentElement('beforebegin', indexSection);
        }
    });

    Array.from(expandableListTitles).forEach(item => {
        item.setAttribute('tabindex', '0');

        item.addEventListener('click', e => {
            toggleListTitle(e.currentTarget);
            e.stopPropagation();
        });

        item.addEventListener('keydown', e => {
            if (e.key !== 'Tab' && e.key !== 'Shift') {
                e.preventDefault();
                toggleListTitle(e.currentTarget);
                e.stopPropagation();
            }
        });
    });

    const { location } = document;

    if (location.hash && location.hash !== '#' && expandableLists.length > 0) {
        const title = document.querySelector(location.hash);
        if (title) {
            const definition = title.nextElementSibling;

            if (definition) {
                title.classList.add('open');
                definition.classList.add('open');
            }
        }
    }

    const askAQuestion = document.querySelector('#footer79');
    if (askAQuestion) {
        setFeedbackLink(askAQuestion, 'AskAQuestion');
    }

    const askAQuestion2 = document.querySelector('#contactus_askaquestion');
    if (askAQuestion2) {
        setFeedbackLink(askAQuestion2, 'AskAQuestion');
    }

    const feedbackLink = document.querySelector('#contactus_feedback');
    if (feedbackLink) {
        setFeedbackLink(feedbackLink, 'Feedback');
    }

    const feedbackLink2 = document.querySelector('#footer137');
    if (feedbackLink2) {
        setFeedbackLink(feedbackLink2, 'Feedback');
    }
});
